<template>
  <div class="newsList">
    <div class="news">
      <p class="p-tt">{{ detailspro.prIssueName }}<span class="tips">{{typeInfo[detailspro.prRightsType]}}</span></p>
      <div class="details">
        <div class="picture">
          <img
            class="img"
            v-if="detailspro.prIssueCover"
            :src="
              detailspro.prIssueCover.substring(0, 4) == 'http'
                ? detailspro.prIssueCover
                : imgUrl + detailspro.prIssueCover
            "
            alt=""
          />
        </div>
        <div class="txeter">
          <ul>
            <li>
              项目编号：<span>{{ detailspro.projectCode || "暂无" }}</span>
            </li>
            <li>
              发行节点：<span>{{ detailspro.nodeName || "暂无" }}</span>
            </li>
            <li>
              发行时间：<span>{{ detailspro.deliverConfirmTime || detailspro.createTime || "暂无" }}</span>
            </li>
            <li>
              发行数量：<span>{{ detailspro.prNum || "暂无" }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="message">
        <div v-if="issue_rights_desc_1.length > 0" style="padding-bottom: 32px;">
          <div class="contentHeader">许可事项</div>
          <div
            class="pto"
            v-for="(item, index) in issue_rights_desc_1"
            :key="index"
          >
            <span>{{ index + 1 + "." + item.value }}</span
            ><br />
          </div>
        </div>
        <div>
          <div class="contentHeader">版权介绍</div>
          <p class="pto" style="text-indent: 2em">{{ detailspro.prIssueContent }}</p>
          <img
            class="imgurl"
            v-if="detailspro.prIssueCover"
            :src="
              detailspro.prIssueCover.substring(0, 4) == 'http'
                ? detailspro.prIssueCover
                : imgUrl + detailspro.prIssueCover
            "
            alt=""
          />
        </div>
      </div>
      <!-- <div class="hot" >
                <div class="logoo">
                    <img src="../../../../assets/容器@2x.png" alt="">
                    <span>热门推荐</span>
                </div>
                <div class='hotItem' v-for='(item,idx) in recommendGoodsList' :key='idx' @click='changeCom(item)'>
                    <div class="hot-img">
                        <img v-if="item.prIssueCover" :src="item.prIssueCover.substring(0, 4) == 'http'?item.prIssueCover:imgUrl + item.prIssueCover" alt="">
                    </div>
                    <div class="hot_box_name">
                        <p class="box_name">{{ item.prIssueName }}</p>
                        <p class="box_name">
                            <span>{{ item.prIssueContent }}</span>
                        </p>
                    </div>
                </div>
            </div> -->
    </div>
  </div>
</template>

<script>
import { postVdetalis, postVlist } from "@/api/index.js";
export default {
  data() {
    return {
      imgUrl: "https://files.wespace.cn",
      typeInfo: {
        '1': '数字版权',
        '2': '正版产品',
        '3': '数实融合',
        '4': '附加权益类(铭文)',
        '5': '数字产品' 
      },
      newsList: [],
      query: {
        pageSize: 3,
        currentPage: 1,
      },
      refundPopupWindow: false,
      hotList: [],
      total: 0,
      recommendGoodsList: [],
      detailspro: {},
      issueInfo: {},
      showDetail: false,
      acitveTab: "0",
      tabList: [
        {
          code: "0",
          label: "许可事项",
          top: 600,
        },
        {
          code: "1",
          label: "版权介绍",
          top: 980,
        },
      ],
      issue_rights_desc_1: [],
      issue_rights_desc1_1: [],
    };
  },
  created() {
    this.getNews();
  },
  methods: {
    getNews() {
      let fd = new FormData();
      // fd.append('prIssueId', this.$route.query.goodsVerId)
      fd.append("prIssueId", this.$route.query.prIssueId);
      // fd.append('prIssueId', '1773301081061741096')
      postVdetalis(fd)
        .then((res) => {
          if (res.code == 200) {
            this.detailspro = res.data;
            this.issueInfo = JSON.parse(res.data.prIssueInfo);
            if (
              this.issueInfo.issue_rights_desc_1 &&
              this.issueInfo.issue_rights_desc_1.length
            ) {
              this.issue_rights_desc_1 =
                this.issueInfo.issue_rights_desc_1.filter((val) => {
                  return val.value;
                });
            }
            if (
              this.issueInfo.issue_rights_desc1_1 &&
              this.issueInfo.issue_rights_desc1_1.length
            ) {
              this.issue_rights_desc1_1 =
                this.issueInfo.issue_rights_desc1_1.filter((val) => {
                  return val.value;
                });
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeTab(item) {
      if (item.code == 0) {
        this.acitveTab = item.code;
        document.documentElement.scrollTop = 600;
      }
      this.showDetail = false;
      this.$nextTick(() => {
        this.acitveTab = item.code;
        document.documentElement.scrollTop = item.top;
      });
    },
    postStatus() {
      this.T = setInterval(() => {
        let unid = new FormData();
        unid.append("orderId", this.orderId);
        postqueryOrderPayStatus(unid).then((res) => {
          if (res.code == 200) {
            this.orderStatus = res.data.orderStatus;
            this.isPay = res.data.isPay;
            if (res.data.isPay == "1" && res.data.orderStatus == "1") {
              clearInterval(this.T);
              this.getList();
              this.$message({
                message: "支付成功",
                type: "success",
              });
            } else if (res.data.isPay == "0" && res.data.orderStatus == "2") {
              clearInterval(this.T);
              this.getList();
              this.$message({
                message: "取消支付",
                type: "warning",
              });
            }
          }
        });
      }, 3000);
    },
    postlist() {
      let unid = new FormData();
      unid.append("currentPage", 1);
      unid.append("pageSize", 10);
      postVlist(unid)
        .then((res) => {
          if (res.code == 200) {
            this.recommendGoodsList = res.data.list;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeCom(item) {
      this.$router.push({
        path: "/productDetails",
        query: {
          prIssueId: item.prIssueId,
        },
      });
      // location.reload()
    },
  },
};
</script>

<style lang="scss" scoped>
.contentHeader {
  line-height: 30px;
  font-size: 20px;
  font-weight: bold;
  color: #181818;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.contentHeader::before {
  content: "";
  display: inline-block;
  width: 50px;
  height: 18px;
  background-image: url("../../../../assets/icon@2x.png");
  background-repeat: no-repeat;
  background-size: 100%;
  margin-right: 9px;
}
.logoo {
  font-weight: bold;
  font-size: 20px;
  color: #181818;
  line-height: 28px;
  img {
    position: relative;
    top: 3px;
    left: 5px;
    margin-top: 10px;
    width: 20px;
    height: 20px;
  }
  span {
    display: inline-block;
    padding: 16px 20px 13px 10px;
    cursor: pointer;
    font-weight: bold;
    font-size: 18px;
  }
}

.logo span {
  display: inline-block;
  padding: 16px 20px 13px 28px;
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
}
.logo .active {
  padding: 16px 20px 13px 28px;
  background-color: #396aff;
  background: #396aff;
  border-radius: 8px 8px 0 0;
  color: #f7f8fa;
}
.newsList {
  background: #fff;
  .Popup {
    display: flex;
    .Popup-type {
      width: 50%;
      padding: 24px;
      background: #f7f8fa;
      border-radius: 8px 8px 8px 8px;

      .p1 {
        margin-bottom: 14px;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 24px;
      }

      .p2 {
        margin-bottom: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }

      .p3 {
        margin-bottom: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;

        .p3-a {
          font-size: 16px;
          font-weight: 700;
          color: #ee6f2d;
          line-height: 24px;
        }

        .p3-b {
          margin-left: 3px;
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
        }
      }

      .p4 {
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }

      .p5 {
        margin-left: 3px;
        margin-bottom: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #181818;
        line-height: 24px;

        img {
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }
      }

      .p6 {
        margin-left: 3px;
        margin-bottom: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #181818;
        line-height: 24px;

        img {
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }
      }
    }

    .Popup-valuelist {
      text-align: center;
      margin: 0 auto;

      .p1 {
        padding-top: 13px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }

      .p2 {
        padding-top: 6px;
        font-size: 30px;
        font-weight: 700;
        color: #ee6f2d;
        line-height: 24px;
        padding-bottom: 27px;
      }

      .p3 {
        width: 120px;
        height: 120px;
        border-radius: 8px 8px 8px 8px;
        opacity: 1;
        background-color: #e6ecf2;
        border: 1px solid #f7f8fa;

        img {
          margin-top: 7px;
          width: 104px;
          height: 104px;
        }
      }

      .p4 {
        padding-top: 6px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
      }

      .p5 {
        padding-top: 6px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
      }
    }
  }
  .logo {
    width: 100%;
    margin-bottom: 28px;
  }
  .news {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0 64px;
    .tip {
      padding-top: 28px;
      font-size: 14px;
      line-height: 16px;
      margin-bottom: 28px;
      span:first-child {
        color: #396aff;
      }
      span:nth-child(2) {
        color: #396aff;
      }
    }
    .p-tt {
      font-weight: bold;
      font-size: 30px;
      color: #181818;
      line-height: 42px;
      display: flex;
      align-items: center;
      .tips{
        display: inline-block;
        margin-left: 20px;
        font-size: 14px;
        font-weight: bold;
        color: #0D81E3;
        line-height: 20px;
        padding: 0 8px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #0D81E3;
      }
    }
    .details {
      margin-top: 20px;
      padding-bottom: 32px;
      border-bottom: 1px solid #ECF3FD;
      background: #ffffff;
      /* box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.03);
        border-radius: 12px 12px 12px 12px;
        opacity: 1;
        border: 1px solid #F0F0F0; */
      display: flex;
      .picture {
        .img {
          width: 200px;
          height: 200px;
          border-radius: 4px;
        }
        .usnjk {
          position: absolute;
          left: top;

          width: 121px;
          height: 39px;
          span {
            position: absolute;
            top: 16px;
            left: 37px;
            width: 90px;
            height: 20px;
            font-size: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 16px;
          }
          img {
            width: 121px;
            height: 39px;
          }
        }
      }
      .txeter {
        width: 70%;
        padding-top: 12px;
        padding-left: 24px;
        ul {
          margin: 0;
          li {
            height: 16px;
            font-size: 16px;
            color: #666666;
            line-height: 16px;
            margin-bottom: 20px;
          }
        }
        .matters {
          margin-top: 30px;
          width: 768px;
          height: 92px;
          background: #f7f8fa;
          border-radius: 8px 8px 8px 8px;
          opacity: 1;
          border: 1px solid rgba(57, 106, 255, 0.16);
          margin-bottom: 36px;
          .ers-t1 {
            margin: 12px;
            font-size: 14px;
            /* font-family: PingFang SC, PingFang SC; */
            font-weight: 400;
            color: #333333;
            line-height: 14px;
          }
          .ers-t2 {
            font-size: 14px;
            /* font-family: PingFang SC, PingFang SC; */
            font-weight: 400;
            color: #666666;
            line-height: 22px;
            margin-left: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            /*限制文本行数*/
            -webkit-line-clamp: 2;
            /*子元素的排列方式*/
            -webkit-box-orient: vertical;
          }
        }
        ::v-deep .el-button {
          margin-top: 38px;
          width: 129px;
          height: 36px;
          background: #396aff;
          border-color: #396aff;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
        }
      }
    }
    .message {
      width: 1100px;
      padding-top: 32px;
      .logo {
        font-size: 18px;
        font-weight: bold;
        color: #1d2129;
        line-height: 26px;
        border-bottom: 2px solid #dfe7ff;
        .logo span {
          width: 150px;
          height: 49px;

          display: inline-block;
          padding: 0 32px;
          cursor: pointer;
          font-weight: bold;
          font-size: 18px;
        }
        .logo .active {
          width: 150px;
          height: 49px;
          padding: 0 32px;
          height: 56px;
          background-color: #396aff;
          background: #396aff;
          border-radius: 24px 24px 0 0;
          color: #396aff;
        }
        img {
          width: 25px;
          height: 25px;
        }
      }
      .pto {
        text-align: justify;
        font-size: 16px;
        color: #5E616C;
        line-height: 32px;
      }
    }
    .imgurl {
        display: block;
        width: 780px;
        font-size: 0;
        margin: 0 auto;
        margin-top: 30px;
    }
    .hot {
      cursor: pointer;
      width: 348px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      border: 1px solid #f0f0f0;
      .logo {
        font-size: 20px;
        font-weight: bold;
        color: #1d2129;
        line-height: 26px;
        border-bottom: 2px solid #dfe7ff;
        img {
          width: 25px;
          height: 25px;
        }
      }
      .hotItem {
        padding: 10px;
        border-radius: 1px;
        height: 110px;
        display: flex;
        .hot-img {
          width: 101px;
          height: 101px;
        }
        .hot_box_name {
        }
        img {
          width: 100%;
          height: 101px;
          border-radius: 8px 8px 8px 8px;
        }
        .box_name {
          margin: 9px 12px 12px 12px;
          width: 200px;
          font-size: 14px;
          /* font-family: PingFang SC, PingFang SC; */
          font-weight: 600;
          color: #181818;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          span {
            width: 200px;
            font-size: 14px;
            /* font-family: PingFang SC, PingFang SC; */
            font-weight: 500;
            color: #181818;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .box_price {
          margin-left: 9px;
          color: #d54835;
          font-size: 12px;
          /* font-family: PingFang SC, PingFang SC; */
          font-weight: 600;
          color: #d54835;
          line-height: 17px;
          span {
            font-size: 18px;
            /* font-family: PingFang SC, PingFang SC; */
            font-weight: 500;
            color: #d54835;
            line-height: 17px;
          }
        }
      }
    }
  }
}
</style>
